// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_yHp9wdPdJ",
    "aws_user_pools_web_client_id": "s5moh6dqgce6mc22s4tptmgah",
    "oauth": {}
};


export default awsmobile;
